import { memo } from "react";
import styled from "styled-components";
import { showBasemapPanelAtom } from "./BasemapSelectorStore";
import { useAtom, useAtomValue } from 'jotai';
import { selectedBasemapAtom } from "./BasemapSelectorStore";

const BasemapSelector = () => {
  const selectedBasemap = useAtomValue(selectedBasemapAtom);
  const [showPanel, setShowPanel] = useAtom(showBasemapPanelAtom);

  return (
    <UI_Basemap_Wrapper
      onClick={() => {
        setShowPanel(!showPanel);
      }}
    >
      {selectedBasemap && (
        <img src={selectedBasemap.image} style={{ width: '100%', height: '100%', borderRadius: 8, border: '1px solid #333' }} />
      )}
    </UI_Basemap_Wrapper>
  )
};

export default memo(BasemapSelector);

const UI_Wrapper = styled.div`
  position: relative;
`;

const UI_Options_Wrapper = styled.div`
  position: absolute;
  top: 45px;
  right: 0;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  min-width: 200px;
  z-index: 1000;

  @media (max-width: 768px) {
    right: -20px;
    min-width: 240px;
  }

  @media (max-width: 480px) {
    position: fixed;
    top: 56px;
    right: 8px;
    left: 8px;
    min-width: unset;
    width: calc(100vw - 16px);
    max-height: 70vh;
    overflow-y: auto;
    z-index: 1001;
    border: 1px solid rgba(0,0,0,0.1);
  }
`

const UI_Options_Button = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 14px;
  touch-action: manipulation;
  user-select: none;

  @media (max-width: 480px) {
    padding: 12px 16px;
    font-size: 16px;
    min-height: 48px;
  }

  &:hover {
    background-color: var(--color-primary);
    color: white;
  }
  &.active {
    background-color: var(--color-primary);
    color: white;
  }
`

const UI_Basemap_Wrapper = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    padding: 1;
    background-color: gray;
    cursor: pointer;
    touch-action: manipulation;
    user-select: none;

    @media (max-width: 768px) {
      width: 44px;
      height: 44px;
    }

    @media (max-width: 480px) {
      width: 48px;
      height: 48px;
    }
`

const UI_Group_Header = styled.div`
    padding: 8px 12px;
    color: #666;
    font-size: 12px;
`